import React, { useState } from "react";
import { Form, Input, Row, Col, Button, Select, Card, DatePicker } from "lib/ui";
import moment from "moment";
import { convertToReadableDate } from "../../Data/Data";

const { Option } = Select;

const MyForm = ({ form, onFinish, initialValues }) => {
  const [items, setItems] = useState(initialValues.items || []);

  const addItem = () => {
    setItems([
      ...items,
      { image: "", product: "", categoryName: "", quantity: "", price: "" },
    ]);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <Row gutter={16}>
        <Col span={24}>
          <Card
            title="Order Information"
            style={{ marginBottom: 24, borderRadius: 10 }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Created At" name="createdAt">
                  {!initialValues?.items ? (
                    <DatePicker
                      showTime
                      style={{ width: "100%" }}
                      defaultValue={moment()}
                    />
                  ) : (
                    <div>
                      {(() => {
                        const ca = initialValues?.createdAt;
                        if (!ca) return "—";
                        const raw =
                          typeof ca === "object" && ca.$date != null
                            ? ca.$date
                            : ca;
                        const m = moment(raw);
                        return m.isValid()
                          ? m.format("YYYY-MM-DD HH:mm:ss")
                          : "—";
                      })()}
                    </div>
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Order Reference" name="ref">
                  <Input readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Order Status" name="status">
                  <Select>
                    <Option value="active">Active</Option>
                    <Option value="completed">Completed</Option>
                    <Option value="cancelled">Cancelled</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="PickUp Driver" name="driver">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Items Information */}
        <Col span={24}>
          <Card
            title="Items Information"
            style={{ marginBottom: 24, borderRadius: 10 }}
          >
            {initialValues.items &&
            Object.values(initialValues.items).length > 0 ? (
              Object.values(initialValues.items).map((item, index) => (
                <Row
                  key={index}
                  gutter={16}
                  align="middle"
                  style={{ marginBottom: 16 }}
                >
                  <Col span={4}>
                    <img
                      src={item.image}
                      width={50}
                      style={{ borderRadius: 5 }}
                    />
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Product">
                      <Input value={item.product} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Category">
                      <Input value={item.categoryName} />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item label="Quantity">
                      <Input value={item.quantity} />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item label="Price">
                      <Input value={`$${item.price}`} />
                    </Form.Item>
                  </Col>
                </Row>
              ))
            ) : (
              <Button type="dashed" block onClick={addItem}>
                Add Item
              </Button>
            )}
            {items.length > 0
              ? items.map((item, index) => (
                  <Row
                    key={index}
                    gutter={16}
                    align="middle"
                    style={{ marginBottom: 16 }}
                  >
                    <Col span={4}>
                      <img
                        src={item.image}
                        width={50}
                        style={{ borderRadius: 5 }}
                      />
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Product">
                        <Input value={item.product} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Category">
                        <Input value={item.categoryName} />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item label="Quantity">
                        <Input value={item.quantity} />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item label="Price">
                        <Input value={`$${item.price}`} />
                      </Form.Item>
                    </Col>
                  </Row>
                ))
              : null}
          </Card>
        </Col>

        {/* Payment Information */}
        <Col span={24}>
          <Card
            title="Payment Information"
            style={{ marginBottom: 24, borderRadius: 10 }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Subtotal" name="subtotal">
                  <Input prefix="AED " readOnly />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Delivery Fee" name="deliveryFee">
                  <Input prefix="AED " readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Discount" name="discount">
                  <Input prefix="AED " readOnly />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Total Price" name="totalPrice">
                  <Input
                    prefix="AED "
                    readOnly
                    style={{ fontWeight: "bold" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Delivery Information */}
        <Col span={24}>
          <Card
            title="Delivery Information"
            style={{ marginBottom: 24, borderRadius: 10 }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Delivery Date" name="deliveryDate">
                  {!initialValues?.items ? (
                    <Input />
                  ) : (
                    <div>
                      {convertToReadableDate(initialValues?.deliveryDate)}
                    </div>
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Pick Time" name="pickTime">
                  {!initialValues?.items ? (
                    <Input />
                  ) : (
                    <div>{convertToReadableDate(initialValues?.pickTime)}</div>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="Delivery Address">
              <Input.TextArea
                value={initialValues?.deliveryAddress?.address}
                rows={2}
                readOnly
              />
            </Form.Item>
          </Card>
        </Col>

        {/* Submit Button */}
        <Col span={24}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%", height: 40, fontSize: 16 }}
            >
              Submit Order
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default MyForm;
